/**
 * KatChan DA — comportements légers.
 *
 * <kc-countdown data-end="2026-11-15T23:59:00+01:00">
 *   Compte à rebours jusqu'à la fermeture de la boutique temporaire.
 *   Remplit les éléments [data-unit="days|hours|minutes|seconds"] et passe
 *   data-state="closed" (affiche .kc-countdown__closed) une fois la date passée.
 *   Une date invalide masque le composant au lieu d'afficher « NaN ».
 */
class KcCountdown extends HTMLElement {
  /** @type {number | undefined} */
  #timer;

  connectedCallback() {
    const end = Date.parse(this.dataset.end ?? '');

    if (Number.isNaN(end)) {
      this.hidden = true;
      return;
    }

    this.end = end;
    this.units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };

    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #tick() {
    const remaining = Math.max(0, this.end - Date.now());

    if (remaining === 0) {
      window.clearInterval(this.#timer);
      this.dataset.state = 'closed';
      this.querySelector('.kc-countdown__closed')?.removeAttribute('hidden');
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };

    for (const [unit, element] of Object.entries(this.units)) {
      if (!element) continue;
      const text = String(values[unit]).padStart(2, '0');
      if (element.textContent !== text) element.textContent = text;
    }

    this.dataset.state = 'open';
  }
}

if (!customElements.get('kc-countdown')) {
  customElements.define('kc-countdown', KcCountdown);
}
